var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDebris(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000119818994496447489480000000095155922296515462_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 351.3 344.7",
    enableBackground: "new 0 0 351.3 344.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M134.9,137.8c8.8,3.8,18.1,5.3,26.5,9.7c4.9,2.6,10,5.1,13.9,9.2c1.1,1.2,2.7,0.6,4.2,0.3 c8.4-1.6,16.7-4,25.2-5.4c1.8-0.3,4.3-1.9,5.6-1.1c1.4,0.9,1.6,3.6,2.4,5.5c0.4,1,0.7,2.1,1.3,3c3.1,4.4,0.8,7.5-2.2,10.9 c-6.5,7.5-13.1,14.9-18.4,23.4c-1.5,2.5-1.7,4.2,0.1,6.8c2.3,3.4,3.1,7.5,4.3,12.1c-4.6-2.6-9.1-4-13.6-5.4 c-6.9-2.2-13.6,0.4-20.3,1.5c-9.2,1.5-18.3,3.9-27.2,6.4c-0.2-7,2-13.6,2.6-20.4c0.4-4.7,2.9-9,3.9-13.7c0.7-3.1,0.2-5.8-0.7-8.2 c-3.1-8.5-6.2-17-7.5-25.9C134.5,143.8,134.9,140.9,134.9,137.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M163.6,114.6c1.6,4.8,3.1,9.1,4.7,14c2-2.5,3.7-4.8,5.6-6.9c4.3-4.8,8.9-9.1,14.8-12 c2.1-1,2.9-1.5,3.8,1.5c1.9,6.6,4.5,13,6.9,19.5c0.5,1.3,0.8,2.3-0.5,3.2c-6.6,4.9-13.3,9.8-19.9,14.8c-1,0.8-1.8,1.6-3.2,0.6 c-6.1-4.6-12.8-8.1-19.9-10.5c-2.1-0.7-1.9-1.4-1.7-3c0.9-6.5,3.1-12.3,7.7-17.1C162.8,117.6,163.1,116.4,163.6,114.6L163.6,114.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M125,140.5c-5.4-6.8-10.7-13.7-16.1-20.6c-5.9-7.6-11.7-15.2-17.5-22.7c-1.1-1.4-2.4-3-1.4-4.6 c1-1.5,2.7-2.9,4.9-2.7c0.6,0.1,1.3,0,1.8,0.2c10.1,4,20.9,5.8,31.3,8.9c1.6,0.5,2.8,0.8,2.3,3.6c-1.8,11.1-3.2,22.4-3.9,33.7 C126.4,137.7,125.1,138.9,125,140.5L125,140.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M244.2,119c-5.2,6.5-7.9,14.1-10.4,21.6c-1.6,4.6,1.6,9.9,6,12.4c3.7,2.1,7.5,3.9,11.5,5.4 c2.3,0.8,4.6,1.5,7.1,1.4c-4,2.8-8.6,3.9-12.9,5.8c-2.9,1.3-5.9,2.5-8.7,4c-1.6,0.8-2.5,2.1-0.5,3.7c1.1,0.8,2,1.9,1.7,3.5 c-0.1,0.7,0,1.6-1.1,1.5c-0.7-0.1-1.4,1-2.1-0.3c-0.9-1.6-2.5-2.6-3.4-4.4c-1.1-2.2-2.2-4.6-4-6.1c-6.5-5.3-9.1-12.7-11.1-20.3 c-1-3.6-4.1-5.1-5.8-7.9c-0.9-1.6-0.8-2.1,0.7-2.6c8.1-2.8,14.9-8.3,22.5-12.1C237.3,122.9,240.7,120.9,244.2,119L244.2,119z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M222.3,166.4c6.7,13.2,14.6,25.8,22.3,39.7c-3.7-2.6-7.1-1.8-10.3-2.1c-10.1-1-20.3-1.3-30.4-3.2 c-1.5-0.3-3.1-0.7-4.4-1.5c-1.5-0.9-2.6-2.3-1-4.1c6.6-7.6,13.4-15.1,19.5-23.1C219.3,170.2,219.7,167.6,222.3,166.4L222.3,166.4z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M121.9,169.7c-12.5-1.9-23.9,2.9-35.8,2.7c-1,0-1.5,0.3-1.7,1.4c-0.2,1.1,0.2,2.5-1.6,3.2 c-3.6,1.4-6.8,3.9-10.6,4.8c-1.7,0.4,0.2-1.7-1.4-2.6c-4.4-2.4-9.3-2.8-13.8-4.5c-6.1-2.2-12.8-2-19-3.8 c-5.9-1.8-12.3-2.1-17.9-4.8c-1.6-0.8-3.4,0-5.3-0.6c1.2-0.9,2.4-0.5,3.5-0.5c26.8,0,53.6-0.2,80.4,0.1c6.7,0.1,13.5,0.5,20.1,2.2 C119.8,167.4,120.9,167.7,121.9,169.7L121.9,169.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M95.4,277.7c8.6-16.9,17.2-33.5,24.2-51c1.4,1.1,1.4,3.2,2.4,4.7c1.1,1.7,2,3,4.4,1.7 c6.5-3.5,14.1-4.9,20.4-9.9c-0.9,4.7-1.7,8.9-2.4,13.2c-0.1,0.7,0.4,1.5-0.6,1.8c-0.3,0.1-0.8,0.1-1.1-0.1 c-0.9-0.7,0.1-1.3,0.2-1.9c0.1-0.5,0-1-0.2-2.7C125.5,247.6,110.4,262.6,95.4,277.7L95.4,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M340.2,131.8c-4.3,1.9-7.7,4-11.4,4.8c-12.9,2.7-25.1,8-37.9,11c-0.6,0.1-1.2,0.1-2.1,0.1 c2.3,1.9,4.3-0.8,6.4,0.2c-15,6.9-42.2,7.8-52.1,1.3c16.1,0,30.4-6.5,45.4-9.4c9.9-1.9,19.9-4.1,30-5 C325.5,134.2,332.4,132.9,340.2,131.8L340.2,131.8z M266.6,149.6c4.7-0.2,9.6,1.2,14.2-0.9C276.1,149.6,271.3,148.8,266.6,149.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M83,194.4c8.3-4.3,16.1-8.3,23.9-12.4c1.9-1,4.1-1.8,5.7-3.2c5.4-4.9,11.3-3.4,17.2-1.4 c0.2,0.1,0.6,0.1,0.7,0.2c0.9,1.6,3.9-0.6,3.9,1.9c0,1.6-1.2,3.2-1.9,4.7c-1.6,3.4-2.4,8.4-5,9.8c-2.5,1.3-7.1,0-10.8,0 c-7.5,0-15,0-22.4,0C90.6,194,87.2,195.5,83,194.4L83,194.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M51.6,57c5.4,4.5,11.2,7,16.1,11.3c4.6,4,9.8,7.6,15,11c0.1,0.1,0.2,0.1,0.3,0.1c2.3,1.6,5.4,2.8,6.6,5.1 c1.4,2.8-2.6,4.3-3.5,6.8c-0.5,1.2-1.1,2.5-1.4,3.7c-0.2,0.9-0.3,1.7-1.5,1.6c-0.9-0.1-1.7,0.1-2.5-1c-8.5-11.9-18-23-27.3-34.3 C52.4,60.3,51.7,59.3,51.6,57L51.6,57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M163.4,15.2c1,13.4,4.3,26.5,5.9,39.9c0.6,5.1,2,10,3.1,15c0.2,0.8,1.1,1.7-0.5,1.8 c-4.7,0.4-8.9,3.1-13.6,3.6C161,55.4,164,35.5,163.4,15.2L163.4,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M169.8,120.3c-1.8-4.6-3.6-9.2-5.4-13.7c-0.3-0.7-0.8-1.3-1-2c-1.1-3.2-1.2-5.6,2.6-7.6 c4.2-2.2,8.3-4.8,11.7-8.5c1.2,5.7,2,11,3.6,16.1c1.1,3.4,0.4,5.6-2.4,7.4C175.3,114.3,172.7,117.7,169.8,120.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M137.4,223.1c-4.1,1.6-7.9,3.4-11.9,5.5c-2.2-5.6-4.3-11.1-6.6-16.5c-0.8-1.9,0.2-2.9,1.4-4.1 c3.9-3.9,7.8-7.8,11.1-12.3c1.3-1.8,1.4-4.4,4.1-5.7c-0.9,2.6-1.6,5-2.5,7.4c-2.4,6.3-3.7,12.5-2.2,19.3 C131.7,220.6,133.9,222.2,137.4,223.1L137.4,223.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M341.3,191.7c-9.6-0.5-19.4-0.3-29.1-1.3c-4.5-0.5-9.1-0.4-13.7-0.7c-13.3-0.9-26.6-0.9-39.9-2.9 c6.1-0.6,12.2,0.8,18.2-0.9h-17.7l0.1-1.1C286.7,184.2,314,187.4,341.3,191.7L341.3,191.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M184.9,320.6c-3.9-24.5-3.4-48.8-10.2-72.1c4.4,8,9.7,15.5,9.7,25.5c0,5.1,0.4,10.4,0.4,15.5 c0.1,4.8,1.3,9.6,0.8,14.4C185,309.3,184.7,314.6,184.9,320.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M108,86c-3.9-2.1-6.1-5.6-7.7-9.4c-2.9-6.9-6.4-13.4-10.7-19.5c-2.5-3.6-6.5-3.8-9.8-5.7 c2.2-1.6,4.3-3.5,6.6-5.2c2.5-1.8,3.8-1.7,4.9,1.2c3.7,9.8,8.9,19,12.2,28.9C104.7,79.7,106,83,108,86L108,86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M128.5,157.4c-2.1-0.7-4-1.3-5.7-2.5c-11.6-7.6-22.9-15.6-34-23.9c-1.8-1.4-3.7-2.7-5.4-4.3 c-0.4-0.4-1.2-0.6-0.7-1.4c0.6-1.1,1.3-0.3,1.9,0c6.5,2.4,11.9,6.7,17.5,10.5c2.7,1.9,5.3,4.7,7.7,6.1c6.8,3.7,11.4,9.9,18,13.6 C128.3,155.7,128.7,156.1,128.5,157.4L128.5,157.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M151,217.7c8.4-1.3,16.1-2.6,23.6-4.6c1.7-0.5,2.8-1,2.3,2c-0.5,2.9-1.1,5.8-1,8.8c0,1.3-0.3,2.8-2.1,2 c-6.8-2.9-14.6-2.9-21-7.1C152.4,218.6,152,218.3,151,217.7L151,217.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M208.5,117.5c16.9-11.4,33.6-22.7,50.3-33.9l0.2,0.2c-2.8,2.7-5.7,5.5-8.5,8.2c-1.9,1.8-4.1,3.4-5.9,5.3 c-2.6,2.7-5.4,4.5-9.2,5.6c-4.2,1.3-7.4,5-11,7.8C219.8,114.2,215.3,118.1,208.5,117.5L208.5,117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M211.9,242.4c-6.2-6.4-11.8-12-18.1-16.7c-0.7-0.5-1.6-1.2-1.7-1.9c-0.2-1.3-2.5-1.9-1.4-3.4 c1-1.3,3.1-0.6,4-0.1c5.3,3.1,10.7,6.4,15.6,10.1c2,1.5,0.6,4.9,1.6,7.3C212.2,238.9,211.9,240.2,211.9,242.4L211.9,242.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M269.3,165.9c-4.8,2.7-9.7,5.4-14.5,8.1c-2.2,1.3-4.3,2.2-7.1,1.4c-1.9-0.5-4.2-0.5-5.4,2 c-0.6,1.2-1.8,1.1-2.9,0.7c0.4-0.9,0.5-1.9,1.1-2.5c2.1-2.4,4.5-4.5,7.6-5.6c3.7-1.3,7.1-2.9,10.6-4.9 C263.8,162.2,264.3,162.1,269.3,165.9L269.3,165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M248.6,121.3c2.1,0.3,3.2-1.6,4.2-2.6c7.8-7.3,16.8-13.1,24.5-20.4c5.5-5.3,12.7-8.3,18.8-12.7 c0.5-0.4,1.3-0.4,1.7,0.2c0.4,0.6-0.2,1.1-0.6,1.5c-9.5,8.4-20,15.5-30.4,22.8c-4.7,3.3-9.8,6.1-13.9,10.3 c-1.2,1.2-2.6,1.8-4.3,1.8C248.6,121.9,248.6,121.6,248.6,121.3L248.6,121.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M220.6,212.5c0.5,1.9-0.1,2.5-0.5,3.3c-0.7,1.7-1.6,3.3-2.4,4.9c-3.6,7.1-3.6,7.1-10.5,2.8 c-1.4-0.9-1.7-1.5-0.7-2.8c3.1-4.1,6.1-8.2,9.3-12.2c1.1-1.4,2.3-2,2.9,0.7C219.1,210.7,220.2,212,220.6,212.5L220.6,212.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M157.5,267c3.1-11.3,1-23.1,4.6-34.4c1.8,0.5,3.3,2.8,5.5,3.9c0.7,0.3,0.8,1,0.4,1.9 c-4.5,8.8-7.1,18.3-9.9,27.8C158.1,266.4,157.7,266.7,157.5,267z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M223,228c4.6-0.8,8.9-2.9,13.7-3.5c0.6-0.1,1.1-0.4,1.6,0.1c2.9,3.5,6.4,6.7,6.8,12.2 C237.7,232.9,230,231.4,223,228L223,228z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M263.2,221.7c-4.1,0.3-7.7-2-11.7-2.3c-3.6-0.3-7,0.3-10.5,0.5c-1.7,0.1-1.7-0.1-2.4-1.4 c-0.9-1.9,0-3.9-1.1-5.7c-0.5-0.8,0.1-1.5,1.4-1c7.1,2.5,14.3,4.8,21.4,7.4C261.4,219.4,262.9,219.9,263.2,221.7L263.2,221.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M199.4,205.4c4,0.9,8.1,1.4,12.7,1.8c-2.5,3.5-4.8,6.7-7.2,9.8c-1.6,2.1-3.6,0.9-4-0.7 C200.2,212.8,198.3,209.3,199.4,205.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M284.1,63c1,0,6.3,5.1,6.4,6.2c0.1,1.1-3.7,6.2-4.6,6.2c-1.8,0.1-7.9-5.1-7.8-6.7 C278.1,67.9,283.4,63,284.1,63L284.1,63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M241,291.6c-1.4-2.5-2.8-4.6-4-6.8c-1.5-2.8,0.4-4.7,2-6.5c0.6-0.7,1.9-0.6,2.8,0.1 c0.5,0.4,0.9,0.8,1.3,1.3c1.5,2,4.6,4.6,4.1,5.9C246.4,288,243.4,289.5,241,291.6L241,291.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M255.4,197.3c12.4,1.1,24.8,2,36.8,5.6C279.7,202.6,267.3,201.4,255.4,197.3L255.4,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M220.7,330.1c0.2,0.6,0,0.9-0.6,1.1c-0.6,0.2-1.1,0.5-1.7,0.8c-1.9,0.9-3.2,3.8-5.5,2.5 c-2.1-1.3-2.6-7.8-1.4-10.1c0.3-0.6,0.3-1.4,1.4-1.4C214.6,323,220.6,328.4,220.7,330.1L220.7,330.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M109.2,163c-27.9-2-55.8,1.4-83.7-0.1C53.4,163.4,81.3,160.4,109.2,163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M203.9,74.6c-0.9,7.1-1.9,14.1-2.9,21.6c-1.7-2.7-1.5-10.8,0.6-24.4C202.5,72.7,203.2,73.7,203.9,74.6 L203.9,74.6L203.9,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M310.2,122.1c-1.1,0.2-2.3-0.4-2.9-1.1c-0.8-1,0.7-1.6,1.2-2.4c1.3-2.1,2.6-4.1,4-6.1 c0.6-0.8,0.7-2.6,2.1-2.2c2,0.6,2.8,2.7,3.5,4.5c0.5,1.2-0.5,2-1.9,2.1c-1.6,0.1-1.8,1.6-2.3,2.6 C313.1,121.1,312.3,122.3,310.2,122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M248.6,121.3c0,0.3,0,0.6,0,0.9c-0.1,2.5-3.7,1.6-3.9,4.3c-0.2,3-2.3,5.5-0.3,9.1c1,1.8-2.5,4.9-4.3,7.2 c-0.7,0.9-2,1.2-3.8,2.3c2-5.1,4.1-9.2,5.3-13.6c1-3.7,2.6-6.8,4.9-9.6C247,121.1,247.5,120,248.6,121.3L248.6,121.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M351.3,148.5c-0.2,1.9-0.6,3.8-2.8,4.6c-2.8,1-2.4-2.2-3.5-2.7c-3.1-1.5-2.4-3.3-1.1-5.3 c0.9-1.5,2.2-2.6,4-1.8C350,144.2,351.2,145.9,351.3,148.5L351.3,148.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M261.4,309.3c3.3-1,5.5-2,6.8-4.6c0.3-0.7,0.7-3.3,2.3-1.3c1,1.3,4.2,2.1,2.1,4.8 c-1.4,1.8-3.2,3.6-5.2,3.9C265.8,312.4,263.9,310.6,261.4,309.3L261.4,309.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M65.1,244.3c1,0.1,2.3,0.4,1.7,1.3c-1.2,1.7-1.4,3.9-2.6,5.6c-1.5,2-3.5,1.5-5.1,0.1 c-1.7-1.5-1.4-3.2,0.2-4.6C60.9,245.2,63.3,245.3,65.1,244.3L65.1,244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M276.3,204.5c7.2-0.3,13.7,1.4,19.1,6.6c-6.9-2.8-14.5-3.3-21.5-5.7C274.8,205,275.5,204.8,276.3,204.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M336.3,236.5c-0.4,2.1-0.9,4.5-3.6,4.7c-2.3,0.1-2.9-2.4-2.9-4c0-2,1.2-4.4,3.4-4.6 C335.2,232.3,336.2,234.3,336.3,236.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M250,133.7c6.2-2.1,10.9-6,17.4-6.9C262.7,131.7,258,135.5,250,133.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M219.5,84.3c5.4-9.5,10.6-19.1,15.9-28.6C232.1,66.3,225.7,75.3,219.5,84.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M58.9,112.9c-1.3,0.9-2,1.4-2.6,1.9c-2.1,1.6-3.5,0.3-4.7-1.2c-1.2-1.5-2.6-3.2-0.8-5.2 c0.8-1,1.5-1.5,2.7-0.3C55.1,109.6,57,111.1,58.9,112.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M133.7,51.2c-1.2,0.3-2.7,3.5-4.7,2.2c-2-1.3-1.1-4.3-0.9-6.6c0.1-0.5,0.2-1.1,0.3-1.8 C130.2,47.1,132,49.1,133.7,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M158.1,105.6c3.9,5.6,3.7,9.9-0.7,13.1C156.6,114.2,157.7,109.9,158.1,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M132.2,317.7c2.1,0,4-0.3,3.9,2.2c-0.1,2.2-1.5,3.7-3.7,3.8c-2.3,0.1-2.7-1.9-2.9-3.5 C129.2,317.8,130.9,317.6,132.2,317.7L132.2,317.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M275.5,281.7c1.7-0.2,3.2,0.5,4.5,1.2c1,0.5,2.4,1.9,1.2,2.9c-0.8,0.7-1.7,2.8-3.9,1.2 c-1.5-1.1-2.5-2.6-3.4-3.9C272.5,281.2,274.8,282.1,275.5,281.7L275.5,281.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M152.3,221.4c0.2,6.8-2.5,12.9-4.6,19.2C148.9,234.1,149.7,227.5,152.3,221.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M20.3,139.4c-1.5-0.7-3.1-1.6-3.2-3.5c-0.1-1.9,1.8-2.9,3.2-3c1.7-0.2,2.9,1.8,3,3.1 C23.5,137.4,22.3,139,20.3,139.4L20.3,139.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M339.9,53.6c0.8,2.8,4.8,3.7,2.7,7.1c-0.8,1.3-2.4,1.2-3.5,0.2C336.4,58.5,338.4,56.4,339.9,53.6 L339.9,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M60,86.4c1.7-0.6,2.7,0.1,3.8,1.1c2.1,1.9,3.7,4.4,6.3,5.7c0.6,0.3,1.1,0.9,0.7,1.5 c-0.1,0.3-1.1,0.5-1.3,0.4C66.6,92,61.8,90.8,60,86.4L60,86.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M117.6,300.5c-1.3-0.7-2.5-1.4-2.3-3c0.2-1.7,0.6-3.5,2.8-3.7c1.9-0.1,2.1,1.4,2.3,2.7 C120.7,298.6,118.9,299.3,117.6,300.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M256.1,138.3c-3.4,2.3-7,2.9-11,3.4c1.4-3.6,3.3-5.9,7-3.5C253.6,139.1,254.6,137.6,256.1,138.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M5.7,183.1c-0.8,1.5-1.3,3.2-3.4,3.5c-1.7,0.2-2.3-1.2-2.3-2.2c0-1.6,0.6-3.3,2.6-3.8 C4.6,180.1,4.4,182.5,5.7,183.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M232.1,69.4c-1.5,3.5-3,7-4.5,10.5c-0.5,1.3-1.6,2.1-2.7,1.4c-1-0.6,0-1.7,0.6-2.5 C227.9,75.8,229,72,232.1,69.4L232.1,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M135,92.9c-1.6-7.3-4.7-14-7.4-21.5C131.1,75.6,135.4,88.4,135,92.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M115.1,2.2c1.6,0.6,2.1,2.1,2.3,3.7c0.2,1.9-1.5,2.4-2.6,2.2c-1.1-0.3-2.9-1.1-2.5-2.8 C112.6,4,113.1,2.4,115.1,2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M110.2,339.4c1.7,0.4,2.8,1.3,2.8,3.2c0,1.9-1.4,2.1-2.8,2c-2.1,0-2.2-1.7-2.3-3.1 C107.6,340,108.6,339.4,110.2,339.4L110.2,339.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M94.7,234c0.6,0.4,1.8,1,1.6,2.1c-0.2,1.8-1.1,3.8-2.9,4.2c-1.5,0.3-2-1.7-2.1-2.9 C91.1,235.5,92.8,234.8,94.7,234L94.7,234z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M184.5,226.5c0.5,1.1,0.6,1.6,0.7,2.3c0.1,1.2-1.3,4.1,2.3,3.2c0.5-0.1,1.6,2.2,1.8,3.6 c0.2,1.1-0.8,1-1.5,1.1c-1.5,0.3-2.6-0.5-2.7-1.8C184.9,232.3,183.5,229.8,184.5,226.5L184.5,226.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M79.2,249.8c-0.1-2.5,1.7-2.9,3.3-3.2c1.5-0.3,2,1.6,1.8,2.1c-0.7,1.6-1.9,3.4-3.7,3.5 C79.3,252.4,79.2,250.9,79.2,249.8L79.2,249.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M281.9,169.2c5-0.9,9.3-4.5,14.6-3.9C291.8,167.2,287.2,169.5,281.9,169.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M102.7,273.2c2.7-4.4,6.9-7.3,10.7-10.6C110.8,267,106.6,269.9,102.7,273.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M150.3,93.9v24.9l-0.4,0V93.8L150.3,93.9L150.3,93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M223,105.7c4-4,8.2-7.8,13.9-9.3C232.2,99.4,227.6,102.5,223,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M157.9,302.2c3-0.4,2.8,2,4.3,2.4c-0.8,1.1-1.5,2.4-2.9,2.6c-1.6,0.2-2.1-0.9-2.1-2.4 C157.1,303.4,157.3,302.3,157.9,302.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M146.5,98.7V78l0.7,0v20.7C147.2,98.7,146.5,98.7,146.5,98.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M259.6,109.2c3.8-3,7.6-6.1,11.4-9.1c0.2,0.3,0.4,0.6,0.6,0.8c-3.3,2.8-6.6,5.6-10,8.3 C261.2,109.5,260.3,109.1,259.6,109.2L259.6,109.2L259.6,109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M194.4,230.9c3.3,1.4,5.9,3.4,8.1,6c0.3,0.4,1.2,0.7,0.6,1.4c-0.7,1-1.3,0.2-1.7-0.3 C199.1,235.6,196.7,233.2,194.4,230.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M295.2,104.1c1.1,0.2,2.4,0,1.9,1c-0.8,1.5-0.8,3.8-3,4.3c-1.3,0.3-1.3-0.7-1.3-1.6 C292.6,105.6,293.8,104.7,295.2,104.1L295.2,104.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M243.3,1.5c-0.2,2.3-2.5,1.7-3.8,2.5c-1,0.6-1.5-0.5-1.4-1.3c0.2-1.8,1.4-2.7,3.2-2.7 C242.4,0,243.5-0.1,243.3,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M259.5,109.1c0.2,0.7,0.4,1.2-0.5,1.9c-3.4,2.7-6.6,5.5-10.1,8c3-3.9,6.5-7.2,10.7-9.8 C259.6,109.2,259.5,109.1,259.5,109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M276.3,204.5c-0.8,0.3-1.6,0.6-2.4,0.9c-3.5-0.1-6.5-1.8-9.6-3C268.3,203,272.3,203.7,276.3,204.5 L276.3,204.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M325.8,208c-0.2-1.4,0.1-2,1.5-2c1.5,0.1,2.2,0.9,2.2,2.4c0,1.5-0.9,2.3-2.3,2.1 C325.3,210.4,326.4,208.6,325.8,208L325.8,208z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M305.1,7.8c0.4-1.3,1-1.9,2.4-1.9c1.7,0.1,2.9,0.9,3.2,2.4c0.4,1.9-1.8-0.4-2,1 C307.7,8.5,305.6,9.8,305.1,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M133,336c-1.5-1-4.6,2.2-4.9-1.2c-0.2-2.8,2.2-2.9,3.8-1C132.2,334.1,133.5,334.8,133,336L133,336z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M99.1,173.3h10.3C105.4,175.2,102.3,174.8,99.1,173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M275.2,191.4c4.3-0.8,7.2,0.8,10.3,0.9C282.3,193.6,279.3,192.8,275.2,191.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M307,204.8c-4.6,1.1-8.9-0.2-13.3-1.4C298.2,203.8,302.6,204.3,307,204.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M52.1,10.7c-1.7-1.1-3.6,2.1-4.9-0.7c-0.7-1.5,0.8-1.9,1.7-2.3C51.1,6.9,51.4,8.8,52.1,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M143.3,127.3c0-5-1.8-9.8-0.6-14.8C142.4,117.4,144.4,122.3,143.3,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M204,74.6c-0.3-4.4-1.1-8.9,0.8-13.2C204.1,65.8,204.7,70.2,204,74.6C203.9,74.6,204,74.6,204,74.6 L204,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M118.4,258.8c2.7-2.7,5.3-5.3,8-8l-1-0.9c-2.7,2.7-5.3,5.3-8,8C117.8,258.2,118.1,258.5,118.4,258.8 L118.4,258.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M198.1,77.9c0.8,4.4-1.9,8.4-1.4,12.8C195.4,86.2,197.4,82.1,198.1,77.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M90.8,110.2c-2.4-1.5-5.2-2.5-6.1-6.7C87,106.1,88.9,108.1,90.8,110.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M79.2,193.1c-2.6,2.5-5.6,3.9-9.2,4.1C73.1,195.9,76.1,194.5,79.2,193.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M72.9,228.4c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1,0.2-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2L72.9,228.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebris);
export default __webpack_public_path__ + "static/media/debris.46326a22cd55d010277709e0fe711b86.svg";
export { ForwardRef as ReactComponent };